import moment, { Moment } from "moment";

export type Schedule = {
  startAt: Moment;
  endAt: Moment;
  title: string;
}

export const schedules: Array<Schedule> = [
  {
    startAt: moment('2026-04-02T00:00:00+0900'),
    endAt: moment('2026-04-02T01:40:00+0900'),
    title: '令和8年4月2日(木)00:00～03:00',
  },
];

export const getCurrentSchedule = (now: Moment, schedules: Array<Schedule>): Schedule | undefined => {
  return schedules.find(x => x.endAt > now && now >= x.startAt)
}
